var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.declinationComponent,{tag:"component",class:_vm.declinationClass,attrs:{"declination-data":_vm.sectionData}})}
var staticRenderFns = []

export { render, staticRenderFns }